module.exports = __webpack_public_path__ + "media/合唱.fd4d13b3.wav";